import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { queryKeysInvoiceReprocessing } from '../queryKeys';

import { createInvoiceProcessStopperRule } from './createInvoiceProcessStopperRule';
import { type CreateStopperRulePayload } from './types';

/**
 * A custom hook to create a stopper rule for an invoice process.
 * Uses the `useMutation` hook from `@tanstack/react-query` internally.
 * @returns A promise that resolves when the stopper rule is created.
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Invoice/operation/create_invoice_process_stopper_rule_vadmin_invoice_stopper_rule_post
 */
export const useMutationCreateInvoiceProcessStopperRule = (
  options?: UseMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (createStopperRulePayload: CreateStopperRulePayload) =>
      createInvoiceProcessStopperRule(createStopperRulePayload),
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: queryKeysInvoiceReprocessing.getStopperRules({}),
      });
    },
    ...options,
  });
};
